import { LitElement, html, css } from '@hh/global.js'

class HHCheckboxWrapper extends LitElement {
  static properties = {
    checked: {
      reflect: true,
    },
  }

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    this.checked = this.querySelector('input')?.checked
  }

  onChange(e) {
    this.checked = e?.target?.checked
  }

  reset() {
    const checkbox = this.querySelector('input[type="checkbox"]')

    if (checkbox) {
      checkbox.checked = false
      this.checked = false
    }
  }

  render() {
    return html`
      <div class="checkbox-container">
        <slot @change="${this.onChange}" name="input"></slot>
        <slot name="label"></slot>
      </div>
    `
  }

  static styles = css`
    .checkbox-container {
      position: relative;
      display: inline-flex;
    }

    ::slotted(input) {
      width: var(--hh-width, 14px);
      height: var(--hh-height, 14px);
      position: absolute;
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      padding: 0;
      margin: 0;
    }

    ::slotted(label) {
      position: relative;
      cursor: pointer;
      padding-left: 1.5000rem;
    }

    ::slotted(label):before {
      content: '';
      -webkit-appearance: none;
      background-color: transparent;
      border: 1px solid var(--hh-color, #000) !important;
      width: var(--hh-width, 14px);
      height: var(--hh-height, 14px);
      display: inline-block;
      position: absolute;
      vertical-align: middle;
      cursor: pointer;
      margin-right: 10px;
      box-sizing: border-box !important;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
    }

    :host {
      position: relative;
      display: inline-block;
    }

    :host([checked='true']) ::slotted(label):after {
      content: '';
      display: block;
      position: absolute;
      top: 45%;
      left: var(--hh-check-left, 2.5px);
      width: var(--hh-check-width, 3px);
      height: var(--hh-check-height, 8px);
      border: solid var(--hh-color, #000) !important;
      border-width: 0 var(--hh-check-border-width, 1px) var(--hh-check-border-width, 1px) 0 !important;
      transform: rotate(45deg) translateX(-25%) translateY(-50%);
    }
  `
}

customElements.define('hh-checkbox-wrapper', HHCheckboxWrapper)
